import {
    Blue5,
    Blue25,
    Blue80,
    Green5,
    Green25,
    Green80,
    Orange5,
    Orange25,
    Orange80,
    Purple5,
    Purple25,
    Purple80,
    Red5,
    Red25,
    Red80,
    Teal5,
    Teal25,
    Teal80,
    Yellow5,
    Yellow25,
    Yellow80,
} from "styles/buildertrendTheme/Colors";

import { cn } from "@btnet/utilities-core";

import { BdsText } from "@buildertrend/components";

import "./EmptyStateCell.less";

const emptyStateColors = {
    red: { cellColor: Red80, cellBorder: Red25, cellBackground: Red5 },
    orange: { cellColor: Orange80, cellBorder: Orange25, cellBackground: Orange5 },
    yellow: { cellColor: Yellow80, cellBorder: Yellow25, cellBackground: Yellow5 },
    green: { cellColor: Green80, cellBorder: Green25, cellBackground: Green5 },
    blue: { cellColor: Blue80, cellBorder: Blue25, cellBackground: Blue5 },
    purple: { cellColor: Purple80, cellBorder: Purple25, cellBackground: Purple5 },
    teal: { cellColor: Teal80, cellBorder: Teal25, cellBackground: Teal5 },
} as const;

interface IEmptyStateCellProps {
    color: keyof typeof emptyStateColors;
    icon: React.ReactNode;
    text: string;
    className?: string;
    ["data-testid"]?: string;
    style?: React.CSSProperties;
}

export function EmptyStateCell({
    color,
    icon,
    text,
    className,
    "data-testid": dataTestId,
    style,
}: IEmptyStateCellProps) {
    const { cellColor, cellBorder, cellBackground } = emptyStateColors[color];

    return (
        <div
            className={cn("EmptyStateCell", className)}
            style={{
                border: `1px solid ${cellBorder}`,
                backgroundColor: cellBackground,
                gap: "var(--bui-token-spacing-1)",
                ...style,
            }}
            data-testid={dataTestId}
        >
            <div
                className="EmptyStateCellIcon"
                style={{
                    background: cellBorder,
                    color: cellColor,
                }}
            >
                {icon}
            </div>
            <div className="EmptyStateCellText">
                <BdsText size="normal-sm" text={text} />
            </div>
        </div>
    );
}
